import axios from 'axios';
import store from "../store";

const api = axios.create({
  baseURL: store.state.baseUrl,
  withCredentials: true,
});

let refreshPromise = null;

api.setAccessToken = (token) => {
  localStorage.setItem("access_token", token);
};

api.clearAccessToken = () => {
  localStorage.removeItem("access_token");
};

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("access_token");
  if (!cfg.headers) cfg.headers = {};
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalReq = error.config;
    if (!originalReq) return Promise.reject(error);

    const isRefreshCall = originalReq.url?.includes("/auth/refresh");
    const isUnauthorized = error.response && error.response.status === 401;

    if (isUnauthorized && !originalReq._retry && !isRefreshCall) {
      originalReq._retry = true;

      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh")
          .then(({ data }) => {
            const token = data.accessToken;
            api.setAccessToken(token);
            return token;
          })
          .catch((err) => {
            api.clearAccessToken();
            throw err;
          })
          .finally(() => {
            refreshPromise = null;
          });
      }

      try {
        const newToken = await refreshPromise;
        originalReq.headers.Authorization = `Bearer ${newToken}`;
        return api(originalReq);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;